import { TrackingEventIds } from './../../../../tracking/constants/TrackingEventIds';
import { FacebookConnectionTrackingEvent } from './../../../../tracking/FacebookConnectionTrackingEvent';
import { TrackingCache } from './../../../../tracking/TrackingCache';


import { BasicTrackingCommand } from "./basis/BasicTrackingCommand";
import { FacebookConnectionTrackingCommandVO } from "./vo/FacebookConnectionTrackingCommandVO";
import { BasicModel } from "../../../model/BasicModel";
import { debug } from "../../../../logging/debug";
import { warn } from "../../../../logging/warn";


export class BasicFacebookConnectionTrackingCommand extends BasicTrackingCommand {
    public execute(objectVars: Object = null): void {
        if (!objectVars) {
            warn("Object with the invitation information missing!");
            return;
        }

        let event: FacebookConnectionTrackingEvent =
            (<FacebookConnectionTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.FACEBOOK_CONNECTION));

        let vo: FacebookConnectionTrackingCommandVO = (<FacebookConnectionTrackingCommandVO>objectVars)
        event.playerId = BasicModel.userData.playerID;
        event.zoneId = BasicModel.instanceProxy.selectedInstanceVO.zoneId;
        event.timestamp = new Date().getTime() / 1000;

        event.facebookExternalState = vo.facebookConnectionState;
        event.facebookId = vo.facebookId;
        event.gameLevel = vo.gameLevel;

        debug(
            "Track FacebookConnection"
            + ", facebookConnectionState: " + vo.facebookConnectionState
            + ", facebookId: " + vo.facebookId
            + ", gameLevel: " + vo.gameLevel
        );

        TrackingCache.getInstance().sendEvent(TrackingEventIds.FACEBOOK_CONNECTION);
    }
}

